<template>
  <div class="orders--page">
   
   <SideNav2/>
    <div class="orders--container">
      <ReturnsShipping/>
    </div>
  </div>
</template>

<script>


import ReturnsShipping from "../components/ReturnsShipping";
import SideNav2 from "../components/SideNav2";

export default {
  components: {
   SideNav2,
    ReturnsShipping
  },


};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>



</style>